export const firebaseConfig = {
  apiKey: 'AIzaSyAUTPulZ7brvcaL_VrU2BZ9B9zC4WihYvg', // TODO finish this
  authDomain: 'jb-drum-sequencer.firebaseapp.com',
  projectId: 'jb-drum-sequencer',
  storageBucket: 'jb-drum-sequencer.appspot.com',
  messagingSenderId: '1061179749725',
  appId: '1:1061179749725:web:944192655c039a90a7e4b4',
  databaseURL: 'https://jb-drum-sequencer-default-rtdb.europe-west1.firebasedatabase.app',
};